import type { FaireProductEntity } from "../../entity_types/product";

export const p_hmp7u98c3d: FaireProductEntity = {
  token: "p_hmp7u98c3d",
  type: "product",
  name: "Tomato screenprinted tea towel",
  brandToken: "b_zqgv7epztb",
  brandName: "Nice life",
  imageUrl:
    "https://cdn.faire.com/fastly/ff2dfca54b10bf10d48662fe1c6c3e693c8518e8d1b2e41cbd43264ff5a01136.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/09bd06d2b27b9a485da2e8cdc46702377b1b86b6dde1def6509a05ec229f1d70.jpeg",
    "https://cdn.faire.com/fastly/e0f9373f398a1442f30842751fa4fee6dfeda886e8194023126d8d8b1eb62b56.jpeg",
    "https://cdn.faire.com/fastly/4470d9d40be0da05f8b028e4be0eb473adb7e54e18e06a8c06ee5bffe2595699.jpeg",
    "https://cdn.faire.com/fastly/a0be971f66869f1bda7ff1094cc35c6db2d8e8fe0fc62a88aa6f7529e402c7a2.jpeg",
  ],
  priceDollars: 10,
  description:
    "• 100% natural cotton flour sack tea towel.\n• 19” by 19”.\n• Screenprinted with water based ink.\n• Each towel is individually screen printed and cured in my studio by hand - therefore please allow slight variance in detail as this is meant to enhance the beauty of a hand printed item by the artist.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:41.698Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
